// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2XUPl","row":"ProcedureTreatmentSummary_row__2zWcw"};